import { Checkbox } from "@mui/material";
import type { ModalComponentProps } from "../../../types/modal.types";
import ConfirmModal from "../confirm.modal";
import React from "react";
import type { usimQuotationObject } from "../../../lib/apis/dtos/request/quotation.request";

interface GetUsimResponse {
  type: "ADD" | "REMAIN" | "CHECK";
  telecom: string;
}
interface UsimTelecomSelectModalProps extends ModalComponentProps {
  used?: usimQuotationObject[];
  onClick: (props: GetUsimResponse[]) => void;
}

const TELECOM = [
  { label: "KT", value: "KT" },
  { label: "LGU+", value: "LG" },
  { label: "SKT", value: "SK" },
]

export default function UsimTelecomSelectModal({ id, onClose, onClick, used }: UsimTelecomSelectModalProps) {

  const [select, setSelect] = React.useState<GetUsimResponse[]>([]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    const checked = event.target.checked;
    if (checked) {
      setSelect((prev) => [...prev, { type: "ADD", telecom: value }]);
    } else {
      setSelect((prev) => prev.filter((item) => item.telecom !== value));
    }
  };

  React.useEffect(() => {
    if (used) {
      const _item = [] as GetUsimResponse[];
      used.forEach((item) => {
        _item.push({ type: "REMAIN", telecom: item.telecom });
      });
      setSelect(_item);
    }
  }, [used]);


  const isAdd = select.some((item) => item.type === "ADD");

  return (
    <ConfirmModal
      className="px-6"
      id={id}
      onClose={onClose}
      title="유심이동 상품 - 항목 추가"
      rightButton={{
        title: "유심이동 상품 항목 추가",
        onClick: () => {
          onClick(select);
          onClose?.()
        },
        variant: !isAdd ? "disabled" : "primary",
        disabled: !isAdd
      }}
    >
      <div className="py-4">
        <p>통신사 구분</p>
        <div className="">
          {TELECOM.map(({ label, value }, index) => (
            <div className="flex-row" key={index}>
              <Checkbox
                disabled={select.find((item) => item.telecom === value)?.type === "REMAIN"}
                checked={select.find((item) => item.telecom === value)?.type === "ADD"}
                onChange={(e) => handleChange(e, value)} />
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </ConfirmModal>
  )
}